import React from "react";
import "./FirstSection.css";
import { Link } from "react-router-dom";

function FirstSection({ listContent }) {
  return (
    <div className="firstsection-container">
      <div className="smalltitles">
        <p>Precision, Innovation, and Reliability</p>
        <p>Advancing Healthcare Technology</p>
      </div>
      <div className="secondtitle">
        <h1>YOUR&nbsp;&nbsp;&nbsp;PARTNER</h1>
        <h2 className="wellness-heading">
          IN
          <Link to="/productsByBrand" className="explore-circle">
            <div className="icon-circle">
              <img
                src="/images/uprightarrow.png"
                alt="arrow"
                className="arrow-icon"
              />
              <span className="explore-text">explore</span>
            </div>
          </Link>
          WELLNESS
        </h2>
        <p className="smalltitle-below">Reliable, Precise, & Innovative</p>
      </div>
    </div>
  );
}

export default FirstSection;
